<!-- Copyright 2025 by Common Good Learning Tools -->
<template><div class="k-lti-chooser k-main-wrapper">
	<div class="k-lti-chooser-home"
		v-if="initialized && mode==''"
	>
		<div class="d-flex align-end justify-center pt-3">
			<div class="k-lti-chooser-top-option k-lti-chooser-top-option-new elevation-3" @click="top_option_clicked('new_activity')">
				<div class="k-lti-chooser-top-option-text">Create a New {{site_config.sparkl_app_name}} Activity</div>
				<k-spacer/>
				<div class="text-center mb-2">
					<k-icon large class="mt-2">fas fa-stars</k-icon>
				</div>
				<div class="k-lti-chooser-top-option-note">Or enter an existing activity URL or ID</div>
			</div>

			<div class="">
				<div class="text-center" style="font-size:21px;">
					Browse or Search <b style="font-weight:900; font-size:24px">{{ site_config.app_name }}</b>
				</div>

				<div class="d-flex align-end justify-center flex-wrap">
					<div class="k-lti-chooser-top-option elevation-3" 
						v-if="main_tabs_to_include.includes('classes')"
						@click="top_option_clicked('courses')"
					>
						<div class="k-lti-chooser-top-option-text mt-2">Browse {{configs.classes.title}}</div>
						<k-spacer/>
						<div class="text-center">
							<k-icon large class="mt-2 mb-3">{{top_option_icon('classes')}}</k-icon>
						</div>
					</div>

					<div class="k-lti-chooser-top-option elevation-3" 
						v-if="main_tabs_to_include.includes('resourcerepos')"
						@click="top_option_clicked('repos')"
					>
						<div class="k-lti-chooser-top-option-text mt-2">Browse {{configs.resourcerepos.title}}</div>
						<k-spacer/>
						<div class="text-center">
							<k-icon large class="mt-2 mb-3">{{top_option_icon('resourcerepos')}}</k-icon>
						</div>
					</div>

					<div class="k-lti-chooser-top-option elevation-3" 
						v-if="main_tabs_to_include.includes('mycollections')"
						@click="top_option_clicked('my')"
					>
						<div class="k-lti-chooser-top-option-text mt-2">Browse Your <nobr>“My Collections”</nobr></div>
						<k-spacer/>
						<div class="text-center">
							<k-icon large class="mt-2 mb-3">{{top_option_icon('mycollections')}}</k-icon>
						</div>
					</div>

					<div class="k-lti-chooser-top-option k-lti-chooser-top-option-search elevation-3" @click="top_option_clicked('search')">
						<div class="k-lti-chooser-top-option-text">Search<!-- All Content in {{site_config.app_name}}--></div>
						<k-spacer/>
						<div class="text-center">
							<k-icon large class="mt-2">fas fa-search</k-icon>
						</div>
						<k-spacer/>
						<div class="k-lti-chooser-top-option-note">by Keywords/Terms or Standards</div>
					</div>
				</div>
			</div>
		</div>

		<FavoritesDialog v-show="initialized && mode==''"
			@go_to_collection="go_to_collection"
		/>
	</div>

	<!-- <div v-if="mode=='favorites'">
		<h2 class="d-flex align-center pt-4 pl-5">
			<div>Favorite Collections</div>
		</h2>

		<FavoritesIndex :lti_chooser="true" @go_to_collection="go_to_collection" @hide_index="mode=''" />
	</div> -->

	<div class="k-lti-chooser-back-wrapper"
		v-if="mode != ''"
	>
		<k-spacer/>

		<k-btn color="primary" class="mr-3"
			@click="back_btn_clicked"
		><k-icon small class="mr-2">fas fa-arrow-left</k-icon> BACK</k-btn>

		<div>When you find the activity you’d like to use for your assignment, click the <k-icon color="#000">fas fa-circle-check</k-icon> button to choose it.</div>

		<k-spacer/>
	</div>

	<div class="k-lti-chooser-collections"
		v-show="mode != ''"
	>
		<div v-if="mode=='courses'">
			<h2 class="d-flex align-center pt-4 pl-5">
				<div>Course Collections</div>
			</h2>

			<CourseIndex :config="configs.classes" lti_chooser @go_to_collection="go_to_collection" @hide_index="mode=''" />
		</div>

		<div v-if="mode=='repos'">
			<h2 class="d-flex align-center pt-4 pl-5">
				<div>{{site_config.resourcerepos_noun}}</div>
			</h2>

			<RepositoriesIndex :config="configs.resourcerepos" lti_chooser @go_to_collection="go_to_collection" @hide_index="mode=''" />
		</div>

		<div v-if="mode=='my'">
			<h2 class="d-flex align-center pt-4 pl-5">
				<div>My Collections</div>
			</h2>

			<MyCollectionsIndex :config="configs.mycollections" lti_chooser @go_to_collection="go_to_collection" @hide_index="mode=''" />
		</div>

		<div v-show="mode=='collection'" data-main-focus-start="true" tabindex="-1">
			<keep-alive><router-view :key="router_key"></router-view></keep-alive>
		</div>
	</div>

</div></template>

<script>
import FavoritesIndex from './../collectionlist/FavoritesIndex'
import FavoritesDialog from '../collectionlist/FavoritesDialog'
import CourseIndex from './../collectionlist/CourseIndex'
import RepositoriesIndex from './../collectionlist/RepositoriesIndex'
import MyCollectionsIndex from './../collectionlist/MyCollectionsIndex'
import { mapState } from 'vuex'

export default {
	components: { FavoritesIndex, FavoritesDialog, CourseIndex, RepositoriesIndex, MyCollectionsIndex },
	
	data() { return {
		pm_verbose: 'show_untrusted',
		pm_initialize_try_count: 0,
		sparkl_pm_data: {},
		initialized: false,
		mode: '',
		back_fns: [],
		sparkl_origin_for_chooser: null,
	}},

	computed: {
		...mapState(['user_info', 'site_config']),

		main_tabs_to_include() { return this.site_config.main_tabs_to_include },

		configs() {
			let customized_tabs = this.site_config.customized_tabs

			return {
				classes: {
					id: 'classes',
					icon: customized_tabs.classes?.icon || 'fas fa-chalkboard',
					title: customized_tabs.classes?.title || 'Courses'
				},
				resourcerepos: {
					id: 'resourcerepos',
					icon: customized_tabs.resourcerepos?.icon || 'fas fa-diagram-project',
					title: customized_tabs.resourcerepos?.title || this.site_config.resourcerepos_noun
				},
				mycollections: {
					id: 'mycollections',
					icon: customized_tabs.mycollections?.icon || 'fas fa-cubes-stacked',
					title: customized_tabs.mycollections?.title || 'My Content Collections'
				},
			}
		},

		router_key() {
			let path = this.$route.fullPath
			// by using these keys, we preserve the right amount of "history" in our components...
			if (vapp.$route.name == 'collection_view') {
				return path.replace(/(\/collection\/.+?)(\/|$).*/, '$1')
			} else {
				return path
			}
		},
	},

	created() {
		// for some reason this is set to 'scroll', which makes it so there is always space for a scroll bar even when we don't need it
		$('html').css('overflow-y', 'auto')
		vapp.lti_chooser_component = this
	},

	mounted() {
		this.$nextTick(() => {
			this.pm_initialize()
		})
	},
	methods: {
		// this is the initialize fn for window B that is embedded in/opened from window A
		// here, we establish the eventListener for postMessages, then wait for a message from window A establishing the connection.
		pm_initialize() {
			// host application origins that are allowed to embed this instance of cureum; brought in via site_config
			// this can be specified as an array...
			let trusted_origins = this.site_config.sparkl_lti_chooser_trusted_origins

			// or by default, the chooser can be embedded in sparkl_origin, as well as localhost and dev.sparkl-ed (for testing purposes)
			if (empty(trusted_origins) || trusted_origins.length == 0) {
				trusted_origins = [this.site_config.sparkl_origin, 'http://localhost:8072', 'https://dev.sparkl-ed.com']
			}

			console.warn('LTIChooserCureum pm_initialize: ', trusted_origins)

			// set up eventListener for postMessages
			window.addEventListener('message', (event) => {
				// event.source is the window that sent the message (the window that included the iframe)
				// event.origin is the origin that sent it; make sure we trust it
				// event.data is what was sent

				// Do we trust the sender of this message?
				if (!trusted_origins.includes(event.origin)) {
					if (this.pm_verbose == 'show_untrusted') {
						if (event.origin == window.location.origin) console.warn('   PMX SPARKL_LTI_CHOOSER !== message in cureum from self')
						else console.warn('   PMX SPARKL_LTI_CHOOSER !== message in cureum from untrusted origin: ' + event.origin, event.data)
					}
					return
				}

				// messages that we're listening to here should all have the form {msg: 'xxx', data: ...}
				if (typeof(event.data) != 'object' || empty(event.data.msg)) {
					return
				}
				let msg = event.data.msg
				let data = event.data.data

				// message from hosting window to establish connection
				if (msg == 'establish_connection') {
					// if we already established the connection, return
					if (this.embedded_source) {
						if (this.pm_verbose) console.warn('   PMX SPARKL_LTI_CHOOSER <-- establish_connection received after connection already established')
						return
					}

					if (this.pm_verbose) console.warn('   PMX SPARKL_LTI_CHOOSER <-- EMBEDDED_SOURCE ESTABLISHED FROM HOST', data, event.origin)

					// we could potentially have multiple sparkl origins connecting to this cureum; store the one we're connecting to here
					this.sparkl_origin_for_chooser = event.origin
					// TEMP: set this for testing
					// this.sparkl_origin_for_chooser = 'https://sparkl-ed.com'

					// it looks like we get errors if embedded_source is reactive -- but that's OK; it doesn't need to be
					this.embedded_source = event.source
					this.embedded_source_origin = event.origin

					// if we get to here, send a confirmation message that the establish_connection message has been received
					this.pm_send('received_establish_connection')

					// data should include a sparkl_session_id along with the user's email, name_given, and name_family
					this.sparkl_pm_data = data

					// call a service here to verify the sparkl session. however, we want to make sure we start a NEW session here, so clear U.session_id first
					U.session_id = ''
					const payload = {
						sparkl_origin_for_chooser: this.sparkl_origin_for_chooser,
						sparkl_session_id: this.sparkl_pm_data.sparkl_session_id, 
						email: this.sparkl_pm_data.email, 
						name_given: this.sparkl_pm_data.name_given, 
						name_family: this.sparkl_pm_data.name_family, 
					}
					U.ajax('authenticate_lti_chooser_from_sparkl', payload, result=>{
						// console.warn('authenticate_lti_chooser_from_sparkl', result)
						if (result.status != 'ok') {
							// if status is 'user_does_not_exist', we don't have a cureum user for this email; no matter what the status is, let LTIChooserSparkl know this isn't working
							this.pm_send('authentication_error', result)
							// then return
							return
						}
				
						// set the session_id to the received cureum_session_id
						U.session_id = result.cureum_session_id

						// set user_data as done in initialize_app
						this.$store.commit('set', ['user_info', new User_Info(result.user_info)])

						// set up site_config as done in initialize_app (we should always get site_config)
						if (result.site_config) {
							// set property-by-property, so that we retain default values set above
							for (let key in result.site_config) {
								this.$store.commit('set', [this.site_config, key, result.site_config[key]])
							}
						} else console.log('site_config not received!')
						this.$store.commit('write_site_config')

						// also save subjects
						this.$store.commit('set', ['subjects', result.subjects])

						// call get_classes to get the user's content
						this.$store.dispatch('get_classes').then(x=>{
							this.initialized = true
							this.show_initial_alert()
						})
					})
					

				//////////////////////////////////
				// HERE ARE THE COMMANDS THAT CAN BE SENT FROM THE HOSTING WINDOW

				} else if (msg == 'back_btn_clicked') {
					this.back_btn_clicked(data)

				// } else if (msg == 'xxx') {
				// 	this.xxx(data)

					// more messages here...
				} else {
					console.warn('   PMX SPARKL_LTI_CHOOSER !== received unprocessed message: ', msg, data)
				}
			});
		},

		pm_send(msg, data) {
			// if we're not embedded, return
			if (!this.embedded_source) return

			if (this.pm_verbose) console.warn('   PMX SPARKL_LTI_CHOOSER --> pm_send: ' + msg)

			try {
				// queue a message to be sent; second param specifies what the origin of the target window must be for the event to be dispatched
				this.embedded_source.postMessage({msg: msg, data: data}, this.embedded_source_origin)
			} catch(e) {
				console.warn('   PMX SPARKL_LTI_CHOOSER !== pm_send error caught: ', e)
			}
		},

		show_initial_alert() {
			this.$alert({
				title: 'Welcome!',
				text: `Use this interface to create a new ${this.site_config.sparkl_app_name} activity, or find an existing activity or other content from ${this.site_config.app_name}, to use with your assignment.`,
				acceptText: 'Got It',
				acceptIconAfter: 'fas fa-circle-arrow-right',
				dialogMaxWidth: 480,
			}).then(y => {})
		},

		top_option_icon(x) {
			if (x == 'classes') return this.site_config.customized_tabs.classes?.icon || 'fas fa-chalkboard'
			if (x == 'resourcerepos') return this.site_config.customized_tabs.resourcerepos?.icon || 'fas fa-diagram-project'
			if (x == 'mycollections') return this.site_config.customized_tabs.mycollections?.icon || 'fas fa-cubes-stacked'
		},

		top_option_clicked(option) {
			if (option == 'search') {
				this.mode = 'search'
				this.show_search({
					default_source: 'site'
				})

			} else if (option == 'new_activity') {
				this.pm_send('create_new_sparkl')

			} else {
				// this will cause the collection tiles to show
				this.mode = option
			}

			// set default back_fn
			this.set_default_back_fn()
		},

		set_default_back_fn() {
			this.back_fns.push(
				() => {
					this.mode = ''
					vapp.hide_search()
				}
			)
		},

		set_sparkl_preview_back_fn() {
			// if we're previewing a sparkl activity and the user clicks back, we want to hide the preview and re-set the back_fn to the default_back_fn defined above
			this.back_fns.push(
				() => {
					// note that it's important to call close_sparkl from sparkl_embed.controller_component
					vapp.$refs.sparkl_embed.controller_component.close_sparkl()
				}
			)
		},

		set_search_back_fn() {
			// if we're previewing a sparkl activity and the user clicks back, we want to hide the preview and re-set the back_fn to the default_back_fn defined above
			this.back_fns.push(
				() => {
					vapp.search_component.done_clicked()
				}
			)
		},

		go_to_collection(collection) {
			// set the back btn to come back to this mode
			let prev_mode = this.mode
			this.back_fns.push(
				() => {
					this.mode = prev_mode
				}
			)

			// then set mode to 'collection'; the route will have been set to the collection route, so the router-view will show the collection
			this.mode = 'collection'
			return
		},

		show_search(params) {
			if (empty(params)) params = {}
			// params.lti_chooser = true
			params.search_only = true
			// params.item_types = ['activities']	// could add 'resources' later if we want to allow creating a sparkl activity from a resource on the fly...

			// call initialize_search to show the ResourceSearch UI
			vapp.initiate_search(params)
		},

		lti_chooser_choose(lti_activity_id, lti_activity_title) {
			this.pm_send('lti_chooser_choose', {
				activity_id: lti_activity_id, 
				activity_title: lti_activity_title
			})
		},

		back_btn_clicked() {
			// if the user clicks the back button in the LTIChooserSparkl component, it will passs control to us here.
			// if we have at least one back_fn to execute, we execute the most recent one, then pop it fron the queue
			if (this.back_fns.length > 0) {
				this.back_fns[this.back_fns.length-1]()
				this.back_fns.pop()

			// otherwise we send a message back that the btn click wasn't handled
			} else {
				this.pm_send('back_btn_not_handled')
			}
		},
	}
}
</script>

<style lang="scss">
.k-lti-chooser {
	background-color:#eee;
	height:100%;

	margin-bottom:0!important;	// cancel margin-bottom for main-wrapper

	.k-main-collection {
		background-color:transparent!important;
	}

	.k-collections-view-wrapper {
		margin-top:0!important;
	}
}

.k-lti-chooser-home {
	min-height:100vh;
}

.k-lti-chooser-back-wrapper {
	position:fixed;
	top:0;
	left:0;
	width:100vw;
	z-index:4;
	display:flex;
	align-items:center;
	border-bottom:1px solid #999;
	background-color:#e3e3e3;
	color:#000;
	// padding:6px 0 8px 0;
	height:48px;
}

.k-lti-chooser-collections {
	margin-top:48px;
}

.k-lti-chooser-top-option {
	width:200px;
	height:156px;
	display:flex;
	flex-direction:column;
	justify-content: center;
	background-color:#eee;
	border:#000 4px solid;
	color:#000;
	text-align:center;
	padding:12px;
	border-radius:12px;
	margin:12px;
	cursor:pointer;
	.v-icon {
		color:#000;
		font-size:48px!important;
	}
	.k-svg-icon {
		width:48px!important;
		height:48px!important;
		font-size:48px!important;
	}
}

.k-lti-chooser-top-option-text {
	font-size:20px;
	line-height:24px;
	font-weight:800;
}

.k-lti-chooser-top-option-note {
	font-weight:normal;
	text-align:center;
	font-size:14px;
	line-height:16px;
	margin-top:8px;
}

.k-lti-chooser-top-option-new {
	background-color:$v-amber;
	height:184px;
}

.k-lti-chooser-top-option-search {
	background-color:$v-indigo-lighten-3;
}

@media (max-width:1180px) {
	.k-lti-chooser-top-option {
		width:160px;
		height:140px;
		border-width:3px;
		padding:8px;
		border-radius:10px;
		margin:10px;

		.v-icon {
			font-size:42px!important;
		}
		.k-svg-icon {
			width:42px!important;
			height:42px!important;
			font-size:42px!important;
		}
	}

	.k-lti-chooser-top-option-new {
		background-color:$v-amber;
		height:164px;
	}


	.k-lti-chooser-top-option-text {
		font-size:16px;
		line-height:19px;
		// font-weight:800;
	}

	.k-lti-chooser-top-option-note {
		font-weight:normal;
		text-align:center;
		font-size:12px;
		line-height:15px;
	}
}

</style>
